<template>
  <div class="c-manage-popup">
    <el-dialog
      width="1024px"
      :title="'よくある質問カテゴリ編集'"
      :show-close="false"
      :visible.sync="dialogVisible"
      :before-close="handleDialogClose"
    >
      <el-form ref="ruleForm" :model="form">
        <div class="c-manage-panel">
          <div class="c-manage-label">
            子カテゴリ
          </div>
          <div>
            <div v-for="(obj, index) in form.faqCategoryList" :key="index" class="c-manage-row m-bottom-3">
              <el-form-item :prop="`faqCategoryList[${index}].categoryName`" :rules="categoryNameRules">
                <el-input v-model="obj.categoryName" maxlength="20" show-word-limit/>
              </el-form-item>
              <img
                v-auth="{ auth: '010218' }"
                src="@/assets/icon/sp-icon-delete-new.svg"
                alt=""
                class="m-left-2 delete-icon"
                @click="deleteFaqCategory(index)"
              />
            </div>
            <div class="c-manage-add">
              <el-button
                v-auth="{ auth: '010218' }"
                circle
                class="add-btn"
                @click="addFaqCategory"
              />
              <span>子カテゴリを追加</span>
            </div>
          </div>
        </div>
      </el-form>
      <div class="c-manage-footer m-top-5">
        <narrow-down @click="updateFaqCategory" class="create-btn">
          {{ $t("button.common.data.create") }}
        </narrow-down>
        <cancel-narrow-down
          class="m-top-1 link-primary"
          @click="handleDialogClose">
          {{ $t("button.common.cancel") }}
        </cancel-narrow-down>
      </div>
      <loading-dialog :dialog-visible="isLoading" />
    </el-dialog>
  </div>
</template>

<script>
import SystemManageApi from "@/api/SystemManageApi";
import errorCodeMsg from "@/utils/error-code-msg";
import statusErrorCodeMsg from "@/utils/status-error-msg";
import narrowDown from "@/components/common/generalButton/NarrowDown";
import cancelNarrowDown from "@/components/common/generalButton/CancelNarrowDown";
import LoadingDialog from "@/components/common/loading/LoadingDialog";

export default {
  name: "CategoriesManagePopup",
  components: {
    narrowDown,
    LoadingDialog,
    cancelNarrowDown
  },
  props: {
    ownerId: String,
    visible: Boolean
  },
  data () {
    return {
      isLoading: false,
      dialogVisible: false,
      form: {
        faqCategoryList: [],
      },
      categoryNameRules: [
        {
          required: true,
          message: this.$t("message.common.validation.required", {
            field: "カテゴリ名",
          }),
          trigger: 'change'
        },
        {
          max: 20,
          trigger: 'change',
          message: this.$t('message.common.validation.max', {
            field: "カテゴリ名",
            length: 20
          })
        }
      ]
    }
  },
  watch: {
    visible (val) {
      this.dialogVisible = val
      if (val) {
        this.searchFaqCategory()
      }
    }
  },
  methods: {
    searchFaqCategory () {
      this.isLoading = true
      this.form.faqCategoryList = []
      SystemManageApi.searchFaqCategory({
        ownerId: this.ownerId,
        pageNumber: 1,
        pageSize: 10000
      })
      .then(({ data }) => {
        if (!statusErrorCodeMsg(data.statusCode, this)) {
          return
        }

        if (data?.body?.body) {
          for (const item of data.body.body) {
            this.form.faqCategoryList.push({
              categoryId: item.categoryId,
              categoryName: item.categoryName
            })
          }
        }
      })
      .catch((error) => {
        errorCodeMsg(error, this)
      })
      .finally(() => {
        this.isLoading = false
      })
    },

    updateFaqCategory () {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.doneUpdateFaqCategory()
        }
      })
    },

    doneUpdateFaqCategory () {
      this.isLoading = true
      SystemManageApi.updateFaqCategory(this.ownerId, {
        categoryList: this.form.faqCategoryList
      })
        .then(({ data }) => {
          if (!statusErrorCodeMsg(data.statusCode, this)) {
            return
          }

          this.$messageIotSuccess(this.$t("message.common.save"))
          this.handleDialogClose()
        })
        .catch((error) => {
          errorCodeMsg(error, this)
        })
        .finally(() => {
          this.isLoading = false
        })
    },

    addFaqCategory () {
      if (this.form.faqCategoryList.length >= 30) {
        return
      }
      this.form.faqCategoryList.push({
        categoryId: null,
        categoryName: null
      })
    },

    deleteFaqCategory (index) {
      this.form.faqCategoryList.splice(index, 1)
    },

    handleDialogClose () {
      this.dialogVisible = false
      this.$emit("update:visible", false)
    }
  }
}
</script>

<style scoped>
.c-manage-panel {
  display: flex;
  height: 380px;
  overflow-y: auto;
}

.c-manage-label {
  width: 124px;
  align-items: flex-start;
}

.add-btn {
  height: 36px;
  width: 40px;
  border: none;
  background: url("../../../assets/icon/sp-btn-add.png") no-repeat;
  background-size: 100%;
  position: absolute;
  top: -8px;
  left: -6px;
}

.delete-icon:hover,
.add-btn:hover {
  opacity: 0.6;
}

.create-btn::v-deep .my-button {
  width: 296px;
}

.c-manage-footer {
  text-align: center;
}

.c-manage-add {
  position: relative;
  padding-left: 34px;
}

.c-manage-row {
  display: flex;
  align-items: center;
}

.delete-icon {
  cursor: pointer;
}

.c-manage-popup::v-deep .el-dialog {
  padding: 40px !important;
}

.c-manage-popup::v-deep .el-dialog .el-dialog__header {
  margin-bottom: 40px;
}

.c-manage-popup::v-deep .el-form-item {
  margin-bottom: 0;
}
</style>
